import { Dialog } from 'antd-mobile'

import { toRegExpValueS } from '@/utils'
import './index.less'

interface IProps {
  data?: any[]
  title?: string
  text?: string
  [key: string]: any
}

const alertDialog = ({ data, title, text, msg = 'error_msg' }: IProps) => {
  Dialog.alert({
    className: 'alert-dailog',
    title: data?.length && data?.length > 0 ? title || '失败原因：' : '',
    content:
      title && !data?.length ? (
        <div className='tips-content-box'>{title || ''}</div>
      ) : (
        <div className='schedule-failure-info-box'>
          {data?.map((item: any, planIndex: number) => (
            <div className='item-info-box' key={planIndex}>
              <div className='top-style'>{toRegExpValueS({ text, data: item })}</div>
              <div className='bottom-style'>{item?.[msg] || ''}</div>
            </div>
          ))}
        </div>
      )
  })
}

export const toRegExpValue = ({ text, data }: any) => {
  const regexp = /^(.*){(.+)}(.*)$/
  const keys = [
    text.replace(regexp, `$1`),
    data[text.replace(regexp, `$2`)],
    text.replace(regexp, `$3`)
  ]
  return keys.join('')
}
export const confirmDialog = ({ data, title, text = '', msg = 'error_msg', onConfirm }: IProps) => {
  Dialog.confirm({
    className: 'alert-dailog',
    title,
    content:
      title && !data?.length ? (
        <div className='tips-content-box'>{title || ''}</div>
      ) : (
        <div className='schedule-failure-info-box'>
          {data?.map((item: any, planIndex: number) => (
            <div className='item-info-box' key={planIndex}>
              <div className='top-style'>{toRegExpValue({ text, data: item })}</div>
              <div className='bottom-style'>{item?.[msg] || ''}</div>
            </div>
          ))}
        </div>
      ),
    onConfirm
  })
}
export default alertDialog
